module.exports = __webpack_public_path__ + "static/media/delete-icon-red.ccef47a6.svg";